if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        // BIONIKA: néhány egyedi sablon (árlista, quick-add modál) rejtett vagy
        // késleltetett `[name=id]` mezővel renderel, ilyenkor a getter null-t ad.
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // ÚJ: kötelező termék-opciók + kiegészítők ellenőrzése kattintáskor (gomb sosem tiltott; piros animált jelzés)
        var ujUnselected = [];
        var ujVp = document.querySelector('variant-radios, variant-selects');
        if (ujVp) {
          ujVp.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
            var hasRadio = fs.querySelector('input[type="radio"]');
            var selEl = fs.querySelector('select');
            if (hasRadio && !fs.querySelector('input[type="radio"]:checked')) ujUnselected.push(fs);
            else if (selEl && !selEl.value) ujUnselected.push(fs);
          });
        }
        // BIONIKA: a „Válasszon kompatibilis márkát" választó a formON KÍVÜL áll
        // (a `form=` attribútummal kapcsolódik hozzá), ezért a fenti bejárás nem
        // találja meg. Több kompatibilitás-érték esetén 2026-07-31 óta NINCS
        // előre bejelölt márka, tehát a választás kötelező — enélkül rossz
        // rendszer kerülne a rendelésbe.
        // BUKTATÓ: `form.id` NEM a form azonosítója! A formban van egy
        // `<input name="id">` (a variáns azonosítója), és a HTMLFormElement
        // névvel elért gyerekei ELFEDIK az `id` property-t — a `form.id` magát
        // az inputot adja vissza. Ezért getAttribute kell.
        var ujFormId = this.form && this.form.getAttribute('id');
        if (ujFormId) {
          document
            .querySelectorAll('[data-bnk-compat][data-bnk-compat-form="' + ujFormId + '"]')
            .forEach(function (fs) {
              if (!fs.querySelector('input[type="radio"]:checked')) ujUnselected.push(fs);
            });
        }

        var ujKiegHibas = [];
        document.querySelectorAll('.kiegeszito').forEach(function (box) {
          box.classList.remove('option-unselected');
          var pm = box.querySelector('.kiegeszito-hiba-uzenet'); if (pm) pm.remove();
          var cb = box.querySelector('input[name=kiegeszito]'); if (!cb || !cb.checked) return;
          var sel = box.querySelector('select[name=kiegeszito_varians]');
          if (sel && !sel.value) ujKiegHibas.push(box);
        });
        if (ujUnselected.length || ujKiegHibas.length) {
          this.handleErrorMessage('Kérem válasszon opciót!');
          ujUnselected.forEach(function (fs) {
            fs.classList.add('option-unselected');
            fs.addEventListener('change', function () { fs.classList.remove('option-unselected'); }, { once: true });
          });
          ujKiegHibas.forEach(function (box) {
            box.classList.add('option-unselected');
            box.addEventListener('change', function () { box.classList.remove('option-unselected'); }, { once: true });
          });
          return;
        }

        // Check variant ID is set
        const variantInput = this.form.querySelector('[name=id]');
        if (!variantInput || !variantInput.value) {
          this.handleErrorMessage('Kérem válasszon opciót!');
          this.highlightUnselectedOptions();
          return;
        }

        const virtualPicker = this.querySelector('.virtual-variant-picker');
        console.log(virtualPicker);
        if (virtualPicker && virtualPicker.dataset.virtualValid === 'false') {
          this.handleErrorMessage('Kérjük, válasszon elérhető méretkombinációt.');
          this.highlightUnselectedOptions();
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (typeof kiegeszitoKosarba === "function") {
              kiegeszitoKosarba();
            }
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
        
        //checkCartAutoAdd();
      }

      highlightUnselectedOptions() {
        // Standard variant picker (variant-radios / variant-selects)
        const variantPicker = document.querySelector('variant-radios, variant-selects');
        if (variantPicker) {
          variantPicker.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown').forEach((fieldset) => {
            const hasSelection = fieldset.querySelector('input[type="radio"]:checked') || fieldset.querySelector('select');
            if (!fieldset.querySelector('input[type="radio"]:checked') && fieldset.querySelector('input[type="radio"]')) {
              fieldset.classList.add('option-unselected');
              fieldset.addEventListener('change', () => fieldset.classList.remove('option-unselected'), { once: true });
            }
          });
        }

        // Virtual variant picker
        const virtualPicker = this.querySelector('.virtual-variant-picker');
        if (virtualPicker) {
          virtualPicker.querySelectorAll('fieldset.virtual-option').forEach((fieldset) => {
            const hasChecked = fieldset.querySelector('input[type="radio"]:checked');
            if (!hasChecked) {
              fieldset.classList.add('option-unselected');
              fieldset.addEventListener('change', () => fieldset.classList.remove('option-unselected'), { once: true });
            }
          });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          if (errorMessage == "Required parameter missing or invalid: id") {
            this.errorMessage.textContent = "Kérem válasszon opciót!";
          }
          else {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
